import React from 'react';
import { Navigate, Route } from 'react-router-dom';
import GestionarRoles from 'sites/admin/inmobiliario/gestionarRoles/GestionarRoles';
import renderConditionalComponent from 'utils/renderConditionalComponent';

const RoutesPermisos = () => {
  const token = localStorage.getItem('token_A');

  return (
    <Route
      path="/permisos"
      element={renderConditionalComponent('Roles', GestionarRoles)}
    >
      <Route
        path="roles"
        element={
          token === null ? <Navigate to={'/ingresar'} /> : <GestionarRoles />
        }
      />
    </Route>
  );
};

export default RoutesPermisos;
